import {Component, OnInit} from '@angular/core';
import {User, UserService} from "../../../services/user.service";
import {ActivatedRoute, Router} from "@angular/router";
import {firstValueFrom} from "rxjs";
import {RoomService} from "../../../services/room.service";
import {
  getMissingFields,
  ProfileField,
  ProfileRequirements,
  ProfileRequirementsService
} from "../../../services/profile-requirements.service";
import { FormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { AvatarComponent } from '../../../components/avatar/avatar.component';
import { ProfileFieldsComponent } from '../../../components/profile-fields/profile-fields.component';
import { NgIf } from '@angular/common';

@Component({
    selector: 'app-edit-profile',
    templateUrl: './edit-profile.component.html',
    styleUrls: ['./edit-profile.component.scss'],
    standalone: true,
    imports: [NgIf, ProfileFieldsComponent, AvatarComponent, MatButtonModule, MatMenuModule, FaIconComponent, MatTooltipModule, MatFormFieldModule, MatInputModule, FormsModule]
})
export class EditProfileComponent implements OnInit {

  loading: boolean = true ;
  saving: boolean = false ;
  user?: User ;

  returnUrl?: string ;

  requirements?: ProfileRequirements ;

  constructor(
    public $users: UserService,
    public $rooms: RoomService,
    public $requirements: ProfileRequirementsService,
    public $route: ActivatedRoute,
    public $router: Router
  ) {

  }

  async ngOnInit() {

    this.loading = true ;

    this.returnUrl = this.$route.snapshot.queryParams['returnUrl'] ;

    try {
      this.user = await firstValueFrom(this.$users.getUserForcedReload());

      if (this.returnUrl) {
        this.requirements = await firstValueFrom(this.$requirements.getRequirementsFromReturnUrl(this.returnUrl));
      }

      this.loading = false ;
    }
    catch (e) {
      console.log(e) ;
      this.loading = false ;
    }
  }

  async save() {
    this.user = await firstValueFrom(this.$users.postUser(this.user!, true)) ;

    if (this.returnUrl)
      this.$router.navigateByUrl(this.returnUrl);
  }

  takeSelfie() {

    let returnUrl = '/edit-profile';
    if (this.returnUrl)
      returnUrl = returnUrl + "?returnUrl=" + this.returnUrl ;

    this.$router.navigate(["/take-selfie"], {queryParams: {returnUrl}}) ;

  }

  deleteSelfie() {
    this.user!.profileImage = undefined ;
  }


  get missingFields(): ProfileField[] {
    if (!this.user || !this.requirements) {
      return [] ;
    }

    return getMissingFields(this.user, this.requirements) ;
  }


}
